import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../_model/user.model';
import { LoginService } from '../_service/login.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-hbo',
  templateUrl: './hbo.component.html',
  styleUrls: ['./hbo.component.scss'],
  providers: [LoginService]
})
export class HboComponent implements OnInit {
  username: string = "";
  password: string = "";
  isLogin: boolean = false;
  constructor(
  	 public router: Router, 
    public _loginService: LoginService,
    private toastr: ToastrService,
    ) { }


  ngOnInit() {
  }

  login(){
  	let user = new User('','');
  	user.username = this.username;
  	user.password = this.password;
  	let data = [{'username':user.username,'password': user.password }
  	];
  	this._loginService.sendLogin({ data })
  	.subscribe(
  		response => this.handleResponse(response),
  		error => this.handleResponse(error)
  		);
  }
  handleResponse(response) { 
    
  	if(response.success){
  		 console.log("success");
       // this.toastr.success('Welcome '+this.username+'.', 'Success!',);
       localStorage.setItem('clientName',response.CLIENTE);
       localStorage.setItem('clientToken',response.token);
       // this.router.navigate(['clientdashboard']);
  	} else if (response.error){
  		this.username = "";
  		this.password = "";
      	this.isLogin = true;
      // this.toastr.error('Username or Password incorrect.', 'Error!');
  	} else {

  	}
  }
}



// WEBPACK FOOTER //
// ./src/app/hbo/hbo.component.ts